/* paex-shipping-offer.js — Free shipping offer - PE engine (2026-10-19).
   Loaded (deferred) by snippets/paex-shipping-offer-config.liquid ONLY while
   Theme settings › Party Expert › "Free shipping offer ON" is checked; the
   config island [data-paex-fso-config] carries the metaobject offers (metro /
   regional / remote, in cents), the postal-prefix zone rules, the switches
   and the fixed UI words.

   One state for every surface — cart drawer + cart page meter (roots
   [data-paex-fso]), the PDP Availability block (reads .state), the
   announcement slide, the shipping page — published as the DOM event
   "paex:offer-change" (detail = state):
     { postal, fsa, region, source: typed|cart|geo|customer|none,
       zone: metro|regional|remote|null, confidence: exact|estimated|unknown,
       offer, subtotal, count, shipN, remaining, unlocked, progress,
       kind: teaser|below|unlocked|none, line, teaser, showFree, details }

   Zone resolution (plan §2): a typed postal ("Deliver to" line, estimator,
   postal sheet — paexDestRead) beats the cart attribute edd_postal, which
   beats the IP location (window.paexGeo, only when the switch allows), which
   beats the customer's province. Prefix match = paexZoneFor (paex-store-core,
   seeded from the Checkout Blocks lists) → "estimated". One cart shipping
   rates call per FULL postal per session (prepare_shipping_rates.json +
   async_shipping_rates.json — exactly what checkout applies) → "exact"; never
   on page load, only after a typed postal or a cart change, never with an
   empty cart. Honesty rules: remote never shows "free", a bar or an amount;
   unknown never shows "unlocked"; "Free*" in the summary only when unlocked
   AND exact. */
(function () {
  if (window.paexShippingOffer) return;
  var island = document.querySelector('[data-paex-fso-config]');
  if (!island) return;
  var cfg = null;
  try { cfg = JSON.parse(island.textContent); } catch (error) { cfg = null; }
  if (!cfg || !cfg.offers) return;

  var EVENT = 'paex:offer-change';
  var ZONE_KEY = 'paex:fso-zone';
  var RATE_ZONE = [[/remote/i, 'remote'], [/regional/i, 'regional'], [/standard/i, 'metro']];
  var rules = typeof paexParseZones === 'function' ? paexParseZones(cfg.rules) : [];
  var exactMemory = {}; // postal -> zone | false (mirror for storage-less browsers)
  var inflight = null;
  var fetchTimer = null;
  var excluded = String(cfg.excluded || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean);

  var state = {
    postal: '', fsa: '', region: null, source: 'none', zone: null, confidence: 'unknown',
    offer: null, subtotal: Number(cfg.subtotal) || 0, count: Number(cfg.count) || 0, shipN: Number(cfg.shipN) || 0,
    remaining: 0, unlocked: false, progress: 0, kind: 'teaser', line: '', teaser: '', showFree: false,
    details: detailsUrl(), texts: cfg.texts || {}
  };

  // the island resolves the link (Theme settings › Offer details link, else the
  // metaobject's page + #free-shipping) — used exactly as given
  function detailsUrl() {
    var base = typeof paexSafeUrl === 'function' ? String(paexSafeUrl(cfg.details) || '') : String(cfg.details || '');
    if (!base) return '';
    return cfg.anchor && base.indexOf('#') === -1 ? base + cfg.anchor : base;
  }
  function cleanPostal(value) { return String(value || '').replace(/\s+/g, '').toUpperCase(); }
  function isFull(value) { return /^[ABCEGHJ-NPRSTVXY]\d[A-Z]\d[A-Z]\d$/.test(cleanPostal(value)); }
  function prettyPostal(value) { var raw = cleanPostal(value); return raw.length === 6 ? raw.slice(0, 3) + ' ' + raw.slice(3) : raw; }
  function regionOf(postal) {
    return typeof paexProvinceFromPostal === 'function' ? paexProvinceFromPostal(postal) : null;
  }
  // Shop money_format ("{{amount}} $" here), the SAME template Liquid's money
  // filter uses for the server-rendered teaser — not the theme's JS template
  // (money_with_currency_format, "CAD $ 99.00"; Sasha 2026-10-19 screenshot).
  function money(cents) {
    var template = String(cfg.moneyFormat || '');
    if (template.indexOf('{{') !== -1) {
      var value = (Number(cents) || 0) / 100;
      var fixed = value.toFixed(2);
      var whole = String(Math.round(value));
      return template
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, fixed.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, fixed.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' '))
        .replace(/\{\{\s*amount\s*\}\}/g, fixed.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(/<[^>]*>/g, '');
    }
    if (window.PaexCartBridge && typeof PaexCartBridge.money === 'function') return PaexCartBridge.money(cents);
    try {
      var locale = ((window.Shopify && Shopify.locale) || 'en') + '-CA';
      return new Intl.NumberFormat(locale, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD' }).format(cents / 100);
    } catch (error) { return '$' + (cents / 100).toFixed(2); }
  }
  // Whole-dollar amounts drop the cents ("$99" / "99 $"), non-breaking space
  // before a trailing "$" (copy rule X2); other amounts keep the shop format.
  function moneyShort(cents) {
    var text = money(cents);
    if (cents % 100 === 0) text = text.replace(/([.,])00(?!\d)/, '');
    return text.replace(/ (\$|CAD)$/, ' $1');
  }
  // {value}: money for amount_off, "50 %" / "50%" for percent_off (FR puts a space)
  function offerValue(offer) {
    if (offer.type === 'percent_off') {
      var pct = String(Number(offer.value) || 0);
      return /^fr/i.test((window.Shopify && Shopify.locale) || '') ? pct + '\u00a0%' : pct + '%';
    }
    return moneyShort(offer.value);
  }
  function fill(template, values) {
    return String(template || '').replace(/\{(\w+)\}/g, function (match, key) {
      return values[key] != null ? values[key] : match;
    });
  }

  function readExact() {
    var map = {};
    try { map = JSON.parse(sessionStorage.getItem(ZONE_KEY) || '{}') || {}; } catch (error) { map = {}; }
    Object.keys(exactMemory).forEach(function (key) { map[key] = exactMemory[key]; });
    return map;
  }
  function writeExact(postal, zone) {
    exactMemory[postal] = zone;
    try {
      var map = JSON.parse(sessionStorage.getItem(ZONE_KEY) || '{}') || {};
      map[postal] = zone;
      sessionStorage.setItem(ZONE_KEY, JSON.stringify(map));
    } catch (error) { /* mirror carries this load */ }
  }

  // ---- destination chain ----
  function destination() {
    var dest = typeof paexDestRead === 'function' ? paexDestRead() : null;
    if (dest) {
      var typed = dest.postal || (dest.place && /\d/.test(dest.place) ? dest.place : '');
      return { postal: cleanPostal(typed), region: String(dest.region || '').toUpperCase() || regionOf(typed), source: 'typed' };
    }
    if (cfg.cartPostal && /^[A-Z]/i.test(cfg.cartPostal)) {
      return { postal: cleanPostal(cfg.cartPostal), region: regionOf(cfg.cartPostal), source: 'cart' };
    }
    var geo = cfg.geo ? window.paexGeo : null;
    if (geo && (geo.postal || geo.regionCode)) {
      return { postal: cleanPostal(geo.postal), region: String(geo.regionCode || '').toUpperCase() || regionOf(geo.postal), source: 'geo' };
    }
    if (cfg.customerRegion) return { postal: '', region: String(cfg.customerRegion).toUpperCase(), source: 'customer' };
    return { postal: '', region: null, source: 'none' };
  }

  function resolveZone(dest) {
    var postal = dest.postal;
    if (postal && isFull(postal)) {
      var exact = readExact()[postal];
      if (exact) return { zone: exact, confidence: 'exact' };
    }
    if (postal && /^[A-Z]\d/.test(postal) && typeof paexZoneFor === 'function') {
      var estimate = paexZoneFor(postal, rules);
      if (estimate) return { zone: estimate, confidence: 'estimated' };
    }
    if (dest.region && excluded.indexOf(dest.region) !== -1) return { zone: 'remote', confidence: 'estimated' };
    return { zone: null, confidence: 'unknown' };
  }

  // ---- compute + publish ----
  function compute() {
    var dest = destination();
    var zoned = resolveZone(dest);
    state.postal = dest.postal;
    state.fsa = dest.postal.slice(0, 3);
    state.region = dest.region;
    state.source = dest.source;
    state.zone = zoned.zone;
    state.confidence = zoned.confidence;
    var offers = cfg.offers;
    var offer = state.zone ? offers[state.zone] || null : offers.metro || null;
    state.offer = offer;
    var threshold = offer ? Number(offer.threshold) || 0 : 0;
    var values = {
      threshold: threshold ? moneyShort(threshold) : '',
      value: offer && offer.value ? offerValue(offer) : '',
      amount: ''
    };
    state.remaining = threshold ? Math.max(0, threshold - state.subtotal) : 0;
    state.unlocked = Boolean(threshold) && state.subtotal >= threshold && offer.type !== 'none';
    state.progress = threshold ? Math.max(0, Math.min(1, state.subtotal / threshold)) : 0;
    values.amount = moneyShort(state.remaining);
    var remote = offers.remote || {};
    if (!offer || offer.type === 'none') {
      state.kind = 'none';
      state.line = fill(offer && offer.none ? offer.none : remote.none, values);
      state.teaser = state.line;
      state.unlocked = false;
      state.progress = 0;
    } else if (!state.zone || state.count === 0) {
      // unknown destination: the neutral teaser only (never "unlocked", never
      // a regional/remote statement); empty cart: the zone teaser
      state.kind = 'teaser';
      state.line = fill(offer.teaser, values);
      state.teaser = state.line;
      if (!state.zone) state.unlocked = false;
    } else if (state.remaining > 0) {
      state.kind = 'below';
      state.line = fill(offer.below, values);
      state.teaser = fill(offer.teaser, values);
    } else {
      state.kind = 'unlocked';
      state.line = fill(offer.unlocked, values);
      state.teaser = fill(offer.teaser, values);
    }
    state.showFree = state.kind === 'unlocked' && state.confidence === 'exact' && offer.type === 'free';
    return state;
  }

  // one-line teaser surfaces (collection strip, phase 2): zone teaser only
  function paintTeaser(root) {
    if (!root || !root.isConnected) return;
    root.setAttribute('data-zone', state.zone || 'unknown');
    var node = root.querySelector('[data-fso-teaser-text]') || root;
    if (node.textContent !== state.teaser) node.textContent = state.teaser;
    root.hidden = !state.teaser;
  }
  function publish() {
    compute();
    document.querySelectorAll('[data-paex-fso]').forEach(paint);
    document.querySelectorAll('[data-paex-fso-teaser]').forEach(paintTeaser);
    document.dispatchEvent(new CustomEvent(EVENT, { detail: state }));
  }

  // ---- meter roots (drawer + cart page; snippets/paex-cart-offer-meter) ----
  function setMessage(node, line) {
    // the {amount}-bearing lines bold the money (design C2): rebuild from text
    // nodes, never innerHTML
    if (!node) return;
    var amount = state.kind === 'below' ? moneyShort(state.remaining) : '';
    var at = amount ? line.indexOf(amount) : -1;
    // dedupe on the FULL line (Sasha 2026-10-21: "Add 9.11 $" stayed while the
    // bar moved to 77.90 $ — the key used to blank the amount, so a cart change
    // that only moved the amount never repainted the text)
    if (node.getAttribute('data-fso-painted') === line) return;
    node.setAttribute('data-fso-painted', line);
    while (node.firstChild) node.removeChild(node.firstChild);
    if (at === -1) { node.appendChild(document.createTextNode(line)); return; }
    node.appendChild(document.createTextNode(line.slice(0, at)));
    var strong = document.createElement('b');
    strong.textContent = amount;
    node.appendChild(strong);
    node.appendChild(document.createTextNode(line.slice(at + amount.length)));
  }
  // BOPIS (lane D, 2026-10-22, seams §1 step 4): a free-SHIPPING promise never
  // paints in a pickup / same-day cart. The Liquid gate (meter snippet, cart
  // page section) is primary; this backstop covers the cart page root, which
  // lives outside the re-rendered region and is repainted on every publish.
  function storeService() {
    var api = window.paexFulfil;
    var svc = api && typeof api.service === 'function' ? api.service() : null;
    return svc === 'pickup' || svc === 'local' ? svc : null;
  }
  function paint(root) {
    if (!root || !root.isConnected) return;
    if (storeService()) {
      root.hidden = true;
      var hideScope = root.closest('.paex-cart__foot') || root.closest('.paex-cart') || document;
      hideScope.querySelectorAll('[data-fso-free]').forEach(function (node) { node.hidden = true; });
      return;
    }
    root.setAttribute('data-zone', state.zone || 'unknown');
    root.setAttribute('data-state', state.kind);
    root.setAttribute('data-confidence', state.confidence);
    setMessage(root.querySelector('[data-fso-msg]'), state.line);
    var bar = root.querySelector('[data-fso-fill]');
    if (bar) bar.style.transform = 'scaleX(' + state.progress.toFixed(3) + ')';
    var add = root.querySelector('[data-fso-add]');
    if (add) add.hidden = state.kind !== 'below';
    // cart page root lives outside the re-rendered region: when the last shipping
    // line left the cart (gift wrap / pickup-only only), hide the promise (review 2026-10-19)
    if (root.getAttribute('data-fso-surface') === 'page') root.hidden = state.count > 0 && state.shipN === 0;
    var scope = root.closest('.paex-cart__foot') || root.closest('.paex-cart') || document;
    scope.querySelectorAll('[data-fso-free]').forEach(function (node) { node.hidden = !state.showFree; });
    scope.querySelectorAll('[data-fso-est]').forEach(function (node) { node.hidden = state.showFree; });
  }
  // A re-rendered details region carries the server's fresh totals (every
  // swap path, including the code modal's, which never publishes cartUpdate).
  function sync(scope) {
    var root = scope && scope.querySelector ? scope.querySelector('[data-paex-fso]') : null;
    if (root) {
      var subtotal = Number(root.getAttribute('data-subtotal'));
      var count = Number(root.getAttribute('data-count'));
      var shipN = Number(root.getAttribute('data-ship-n'));
      if (Number.isFinite(subtotal)) state.subtotal = subtotal;
      if (Number.isFinite(count)) state.count = count;
      if (Number.isFinite(shipN)) state.shipN = shipN;
    }
    publish();
    // exact lookup only on intent: a details swap while the drawer is OPEN is a
    // cart action; the boot swap with the drawer closed is not (plan §2: never on load)
    var drawer = root && root.closest ? root.closest('.modal') : null;
    if (drawer && drawer.hasAttribute('open')) lookup();
  }

  // ---- exact zone: the cart's own shipping rates (one call per postal) ----
  function lookup() {
    if (!cfg.exact || inflight || state.count <= 0) return;
    var postal = state.postal;
    if (!isFull(postal) || readExact()[postal] !== undefined) return;
    var province = state.region || regionOf(postal) || '';
    var names = { AB: 'Alberta', BC: 'British Columbia', MB: 'Manitoba', NB: 'New Brunswick', NL: 'Newfoundland and Labrador', NS: 'Nova Scotia', NT: 'Northwest Territories', NU: 'Nunavut', ON: 'Ontario', PE: 'Prince Edward Island', QC: 'Quebec', SK: 'Saskatchewan', YT: 'Yukon' };
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var address = { country: 'Canada', province: names[province] || province, zip: prettyPostal(postal) };
    var query = 'shipping_address[zip]=' + encodeURIComponent(address.zip) + '&shipping_address[country]=Canada&shipping_address[province]=' + encodeURIComponent(address.province);
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var poll = function (tries) {
      return fetch(cartUrl + '/async_shipping_rates.json?' + query, { headers: headers }).then(function (response) {
        if (!response.ok) return null;
        return response.text().then(function (text) {
          var data = null;
          try { data = text && text.trim() ? JSON.parse(text) : null; } catch (error) { data = null; }
          if (data && data.shipping_rates) return data;
          if (tries > 0) return new Promise(function (resolve) { setTimeout(function () { resolve(poll(tries - 1)); }, 1500); });
          return null;
        });
      });
    };
    inflight = fetch(cartUrl + '/prepare_shipping_rates.json', { method: 'POST', headers: headers, body: JSON.stringify({ shipping_address: address }) })
      .then(function (response) { return response.ok ? poll(4) : null; })
      .then(function (data) {
        var list = (data && data.shipping_rates) || [];
        var zone = null;
        list.forEach(function (rate) {
          var name = String(rate.name || rate.presentment_name || '');
          RATE_ZONE.forEach(function (pair) { if (!zone && pair[0].test(name)) zone = pair[1]; });
        });
        writeExact(postal, zone || false);
        if (zone) {
          var estimated = typeof paexZoneFor === 'function' ? paexZoneFor(postal, rules) : null;
          if (estimated && estimated !== zone && Array.isArray(window.dataLayer)) {
            window.dataLayer.push({ event: 'paex_fso_zone_mismatch', fsa: postal.slice(0, 3), estimated: estimated, exact: zone });
          }
        }
      })
      .catch(function () { /* stays estimated */ })
      .then(function () { inflight = null; publish(); });
  }

  // ---- inputs ----
  function onCart(event) {
    var data = event && event.cartData;
    if (data && Number.isFinite(data.total_price)) {
      state.subtotal = data.total_price;
      if (Number.isFinite(data.item_count)) state.count = data.item_count;
      publish();
      lookup();
      return;
    }
    // line-item JSON (product-form add) carries no total. With a PE drawer on the
    // page its details swap will stamp the fresh totals (sync) — no second read.
    if (document.getElementById('Cart-Drawer-Details')) return;
    clearTimeout(fetchTimer);
    fetchTimer = setTimeout(function () {
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) {
          if (cart && Number.isFinite(cart.total_price)) {
            state.subtotal = cart.total_price;
            state.count = cart.item_count;
            publish();
            lookup();
          }
        })
        .catch(function () {});
    }, 120);
  }

  document.addEventListener('paex:dest-change', function () { publish(); lookup(); });
  document.addEventListener('paex:geo-ready', function () { publish(); });
  // BOPIS: a mode change (pickup ↔ ship) repaints every root through the gate above
  document.addEventListener('paex:fulfil-change', function () { publish(); });
  if (typeof webvista !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && typeof webvista.subscribe === 'function') {
    webvista.subscribe(PUB_SUB_EVENTS.cartUpdate, onCart);
  }

  window.paexShippingOffer = {
    state: state, EVENT: EVENT, config: cfg,
    refresh: publish, paint: paint, sync: sync, money: money, moneyShort: moneyShort,
    fill: fill
  };
  publish();
})();
